import agentNotFoundDictionary from '@widgets/rgs-agent-not-found/i18n/rgs-agent-not-found.dic.json';

export const agentNotFound = {
  AGENT_NOT_FOUND: agentNotFoundDictionary,
};

export const agentNotFoundNamespaces = Object.keys(agentNotFound);
